<template lang="pug">
PrCount.pr-count(v-bind="$props")
  .helper.background(v-nv, @nv-enter="changeValue('decrease')")
    icon(:icon="'fas minus'")
  .input.background(v-nv, @nv-numpad="typed") {{ this.value || 1 }}
  .helper.background(v-nv, @nv-enter="changeValue('increase')")
    icon(:icon="'fas plus'")
</template>

<script>
import styled from "vue-styled-components"

const Props = {
  value: Number,
  xsmall: Boolean,
  small: Boolean,
  outline: Boolean,
  floated: Boolean
}
const PrCount = styled("div", Props)`
  display: flex;
  align-items: center;

  .input {
    flex-grow: 1;
    background: ${props => (props.theme.options.outline || props.outline ? "transparent" : props.theme.color.surface)};
    color: ${props => props.theme.color.onSurface};
    border: ${props => "1px solid " + (props.outline ? props.theme.color.onSurface : props.theme.color.border)};
    border-right: 0;
    border-left: 0;
    padding: ${props =>
      props.xsmall
        ? "0.25em 0.25em; font-size: " + props.theme.font.xsmall
        : props.small
        ? "0.35em 0.5em; font-size: " + props.theme.font.small
        : "0.5em 0.75em; font-weight:300; font-size: " + props.theme.font.base};
  }

  .helper {
    flex-grow: 1;
    background: ${props => (props.theme.options.outline || props.outline ? "transparent" : props.theme.color.surface)};
    color: ${props => props.theme.color.onSurface};
    border: ${props => "1px solid " + (props.outline ? props.theme.color.onSurface : props.theme.color.border)};
    padding: ${props =>
      props.xsmall
        ? "0.25em 0.25em; font-size: " + props.theme.font.xsmall
        : props.small
        ? "0.35em 0.5em; font-size: " + props.theme.font.small
        : "0.5em 0.75em; font-weight:300; font-size: " + props.theme.font.base};
  }
`

export default {
  name: "pr-count",
  components: {
    PrCount
  },
  props: {
    ...Props
  },
  methods: {
    typed($event) {
      if (!$event.detail.value) this.$emit("update:value", 1)
      else this.$emit("update:value", parseInt($event.detail.value))
    },
    changeValue(type) {
      if (type === "increase" && this.value < 9) this.$emit("update:value", this.value + 1)
      else if (type === "decrease" && this.value > 1) this.$emit("update:value", this.value - 1)
    }
  }
}
</script>
